import axios from 'axios';

// Default to /api (dev proxy) unless VITE_API_BASE_URL is provided
const isDev = import.meta.env.DEV;
const baseURL = import.meta.env.VITE_API_BASE_URL || '/api';

export const http = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 15000,
    headers: {
        Accept: 'application/json',
    },
});

// Request interceptor placeholder (useful for global headers/trace IDs)
http.interceptors.request.use((config) => {
    return config;
});

// Response interceptor: return data and normalize errors
http.interceptors.response.use(
    (res) => res.data,
    (error) => {
        const status = error?.response?.status;
        const message =
            error?.response?.data?.message || error?.message || 'Network error';
        // Bubble up 401 so AuthContext can handle re-auth
        if (status === 401) {
            window.dispatchEvent(new CustomEvent('auth:unauthorized'));
        }
        return Promise.reject(new Error(message));
    }
);
